module.exports = __webpack_public_path__ + "static/media/icon-dashboard-declined.00cdf84c.svg";